import { createContext } from "react";

export const SwimLanesContext = createContext();
